export default "__VITE_ASSET__d8dab29a__"